<template>
    <div class="processor">
        <h4>
            {{$t('subscription.processor.billing_data')}}
        </h4>
        <div
                class="form-group"
                :class="{error: $v.form.processor.cust_fname.$error}"
        >
            <label>
                {{$t('labels.processor.cust_fname')}}
            </label>
            <div class="input-group">
                <input
                        type="text"
                        maxlength="255"
                        required="required"
                        :placeholder="$t('placeholder.processor.cust_fname')"
                        class="form-control"
                        :disabled="loading"
                        v-model="form.processor.cust_fname"
                        @input="$v.form.processor.cust_fname.$touch"
                >
            </div>
            <template v-if="$v.form.processor.cust_fname.$error">
                <p
                        class="error-message"
                        v-if="!$v.form.processor.cust_fname.required"
                >
                    {{$t('validations.required', {field: $t('fields.processor.cust_fname')})}}
                </p>
            </template>
        </div>
        <div
                class="form-group"
                :class="{error: $v.form.processor.cust_lname.$error}"
        >
            <label>
                {{$t('labels.processor.cust_lname')}}
            </label>
            <div class="input-group">
                <input
                        type="text"
                        maxlength="255"
                        required="required"
                        :placeholder="$t('placeholder.processor.cust_lname')"
                        class="form-control"
                        :disabled="loading"
                        v-model="form.processor.cust_lname"
                        @input="$v.form.processor.cust_lname.$touch"
                >
            </div>
            <template v-if="$v.form.processor.cust_lname.$error">
                <p
                        class="error-message"
                        v-if="!$v.form.processor.cust_lname.required"
                >
                    {{$t('validations.required', {field: $t('fields.processor.cust_lname')})}}
                </p>
            </template>
        </div>
        <div
                class="form-group"
                :class="{error: $v.form.processor.bill_addr_country.$error}"
        >
            <label>
                {{$t('labels.processor.bill_addr_country')}}
            </label>
            <div class="input-group">
                <select
                        required="required"
                        :placeholder="$t('placeholder.processor.bill_addr_country')"
                        class="form-control"
                        :disabled="loading"
                        v-model="form.processor.bill_addr_country"
                        @input="$v.form.processor.bill_addr_country.$touch"
                >
                    <template v-if="countries.data">
                        <option v-for="country in countries.data" :key="country.id" :value="country.code">
                            {{country.name}}
                        </option>
                    </template>
                    <template v-else>
                        <option selected="selected" disabled="disabled" :value="null">
                            <template v-if="countries.loading">
                                {{$t('loading')}}
                            </template>
                            <template v-if="countries.error">
                                {{$t('error')}}
                            </template>
                        </option>
                    </template>
                </select>
            </div>
            <template v-if="$v.form.processor.bill_addr_country.$error">
                <p
                        class="error-message"
                        v-if="!$v.form.processor.bill_addr_country.required"
                >
                    {{$t('validations.required', {field: $t('fields.processor.bill_addr_country')})}}
                </p>
            </template>
        </div>
        <div v-show="stateRequired"
                class="form-group"
                :class="{error: $v.form.processor.bill_addr_state.$error}"
        >
            <label>
                {{$t('labels.processor.bill_addr_state')}}
            </label>
            <div class="input-group">
                <select
                        required="required"
                        :placeholder="$t('placeholder.processor.bill_addr_state')"
                        class="form-control"
                        :disabled="loading"
                        v-model="form.processor.bill_addr_state"
                        @input="$v.form.processor.bill_addr_state.$touch"
                >
                    <template v-if="country_subdivisions.data">
                        <option
                                v-for="country_subdivision in country_subdivisions.data"
                                :key="country_subdivision.id"
                                :value="country_subdivision.code"
                        >
                            {{country_subdivision.name}}
                        </option>
                    </template>
                    <template v-else>
                        <option selected="selected" disabled="disabled" :value="null">
                            <template v-if="country_subdivisions.loading">
                                {{$t('loading')}}
                            </template>
                            <template v-if="country_subdivisions.error">
                                {{$t('error')}}
                            </template>
                        </option>
                    </template>
                </select>
            </div>
            <template v-if="$v.form.processor.bill_addr_state.$error">
                <p
                        class="error-message"
                        v-if="!$v.form.processor.bill_addr_state.required"
                >
                    {{$t('validations.required', {field: $t('fields.processor.bill_addr_state')})}}
                </p>
            </template>
        </div>
        <div
                class="form-group"
                :class="{error: $v.form.processor.bill_addr_city.$error}"
        >
            <label>
                {{$t('labels.processor.bill_addr_city')}}
            </label>
            <div class="input-group">
                <input
                        type="text"
                        maxlength="255"
                        required="required"
                        :placeholder="$t('placeholder.processor.bill_addr_city')"
                        class="form-control"
                        :disabled="loading"
                        v-model="form.processor.bill_addr_city"
                        @input="$v.form.processor.bill_addr_city.$touch"
                >
            </div>
            <template v-if="$v.form.processor.bill_addr_city.$error">
                <p
                        class="error-message"
                        v-if="!$v.form.processor.bill_addr_city.required"
                >
                    {{$t('validations.required', {field: $t('fields.processor.bill_addr_city')})}}
                </p>
            </template>
        </div>
        <div
                class="form-group"
                :class="{error: $v.form.processor.bill_addr_zip.$error}"
        >
            <label>
                {{$t('labels.processor.bill_addr_zip')}}
            </label>
            <div class="input-group">
                <input
                        type="text"
                        maxlength="20"
                        required="required"
                        :placeholder="$t('placeholder.processor.bill_addr_zip')"
                        class="form-control"
                        :disabled="loading"
                        v-model="form.processor.bill_addr_zip"
                        @input="$v.form.processor.bill_addr_zip.$touch"
                >
            </div>
            <template v-if="$v.form.processor.bill_addr_zip.$error">
                <p
                        class="error-message"
                        v-if="!$v.form.processor.bill_addr_zip.required"
                >
                    {{$t('validations.required', {field: $t('fields.processor.bill_addr_zip')})}}
                </p>
            </template>
        </div>
        <div
                class="form-group"
                :class="{error: $v.form.processor.bill_addr.$error}"
        >
            <label>
                {{$t('labels.processor.bill_addr')}}
            </label>
            <div class="input-group">
                <input
                        type="text"
                        maxlength="255"
                        required="required"
                        :placeholder="$t('placeholder.processor.bill_addr')"
                        class="form-control"
                        :disabled="loading"
                        v-model="form.processor.bill_addr"
                        @input="$v.form.processor.bill_addr.$touch"
                >
            </div>
            <template v-if="$v.form.processor.bill_addr.$error">
                <p
                        class="error-message"
                        v-if="!$v.form.processor.bill_addr.required"
                >
                    {{$t('validations.required', {field: $t('fields.processor.bill_addr')})}}
                </p>
            </template>
        </div>
        <div
                class="form-group"
                :class="{error: $v.form.processor.cust_brcpfcnpj.$error}"
                v-show="cpfRequired"
        >
            <label>
                {{$t('labels.processor.cust_brcpfcnpj')}}
            </label>
            <div class="input-group">
                <input
                        type="text"
                        maxlength="255"
                        required="required"
                        :placeholder="$t('placeholder.processor.cust_brcpfcnpj')"
                        class="form-control"
                        :disabled="loading"
                        v-model="form.processor.cust_brcpfcnpj"
                        @input="$v.form.processor.cust_brcpfcnpj.$touch"
                >
            </div>
            <template v-if="$v.form.processor.cust_brcpfcnpj.$error">
                <p
                        class="error-message"
                        v-if="!$v.form.processor.cust_brcpfcnpj.required"
                >
                    {{$t('validations.required', {field: $t('fields.processor.cust_brcpfcnpj')})}}
                </p>
            </template>
        </div>
    </div>
</template>
<script>
    import Spinner from "./Spinner";
    import { required, requiredIf, email } from 'vuelidate/lib/validators';
    import resources from './../resources';

    export default {
        components: {
            Spinner,
        },
        props: {
            submitting: {
                required: true,
                type: Boolean,
            },
            processorDataChangedHandler: {
                required: true,
                type: Function,
            },
            loading: {
                required: true,
                type: Boolean,
            },
        },
        data(){
            return {
                form: {
                    processor: {
                        cust_fname: '',
                        cust_lname: '',
                        bill_addr: '',
                        bill_addr_city: '',
                        bill_addr_state: null,
                        bill_addr_zip: '',
                        bill_addr_country: null,
                        cust_brcpfcnpj: '',
                    },
                },
                countries: {
                    data: null,
                    loading: false,
                    error: false,
                },
                country_subdivisions: {
                    data: null,
                    loading: false,
                    error: false,
                },
            }
        },
        validations(){
            return {
                form: {
                    processor: {
                        cust_fname: {
                            required,
                        },
                        cust_lname: {
                            required,
                        },
                        bill_addr: {
                            required,
                        },
                        bill_addr_city: {
                            required,
                        },
                        bill_addr_state: {
                            requiredIf: requiredIf(function(){
                                return this.stateRequired;
                            }),
                        },
                        bill_addr_zip: {
                            required,
                        },
                        bill_addr_country: {
                            required,
                        },
                        cust_brcpfcnpj: {
                            requiredIf: requiredIf(function(){
                                return this.cpfRequired;
                            }),
                        },
                    }
                }
            }
        },
        methods: {
            loadCountries(){
                this.countries.data = null;
                this.countries.loading = true;

                resources.countries.index({per_page: 9999, order_by: ['name'], include: ['is_current'],})
                    .then((resp) => {
                        this.countries.data = resp.data.data;
                        this.countries.loading = false;
                        this.countries.error = false;
                    }).catch(err => {
                        this.countries.loading = false;
                        this.countries.error = true;
                    });
            },
            loadCountrySubdivisions(countryCode){
                this.country_subdivisions.data = null;
                this.country_subdivisions.loading = false;
                this.country_subdivisions.error = false;

                if(countryCode){
                    const country = this.countries.data.find(country => country.code === countryCode);

                    if(country){
                        this.country_subdivisions.loading = true;

                        resources.country_subdivisions.index({country_id: country.id, per_page: 9999, order_by: ['name']})
                            .then((resp) => {
                                this.country_subdivisions.data = resp.data.data;
                                this.country_subdivisions.loading = false;
                                this.country_subdivisions.error = false;
                            }).catch(err => {
                                this.country_subdivisions.loading = false;
                                this.country_subdivisions.error = true;
                            });
                    }else{
                        this.country_subdivisions.error = true;
                    }
                }
            }
        },
        mounted(){
            this.loadCountries();
        },
        watch:{
            'form.processor.bill_addr_country'(countryCode){
                this.form.processor.bill_addr_state = null;
                this.loadCountrySubdivisions(countryCode);
            },
            cpfRequired(cpfRequired){
                if(!cpfRequired){
                    this.form.processor.cust_brcpfcnpj = '';
                }
            },
            submitting(value, oldValue){
                if(value === true){
                    this.$v.form.$touch();
                }
            },
            'form.processor': {
                handler(processorData){
                    this.processorDataChangedHandler(processorData, !this.$v.form.processor.$invalid);
                },
                deep: true,
                immediate: true,
            },
        },
        computed:{
            stateRequired(){
                if(!this.countries.data || !this.form.processor.bill_addr_country){
                    return true;
                }

                const country = this.countries.data.find(country => country.code === this.form.processor.bill_addr_country);

                if(!country || (country && this.country_subdivisions.data && this.country_subdivisions.data.length !== 0)){
                    return true;
                }else{
                    return false;
                }
            },
            cpfRequired(){
                return this.form.processor.bill_addr_country === 'BR' || this.requestCountry && this.requestCountry.code === 'BR';
            },
            requestCountry(){
                if(!this.countries.data){
                    return null;
                }else{
                    return this.countries.data.find(country => country.is_current);
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    @import './../styles/variables';
    @import './../styles/classes';
</style>